<template>
	 <div class="login-container">
	    <div class="login-border">
	      <div class="login-main">
	        <div class="login-logo">
	          <!-- <img src="~@/assets/image/logo_100.png" alt="logo"> -->
	        </div>
	        <el-form class="login-form" status-icon   label-width="0" size="default">
	            <el-form-item prop="username">
	              <el-input size="small"  v-model="username" auto-complete="off" placeholder="请输入账号">
	                <i slot="prefix" class="el-icon-user"/>
	              </el-input>
	            </el-form-item>
	            <el-form-item prop="password">
	              <el-input size="small"   v-model="password" show-password auto-complete="off" placeholder="请输入密码">
	                <i slot="prefix" class="el-icon-key"/>
	              </el-input>
	            </el-form-item>
	            <el-form-item  prop="login_code">
	              <el-row :span="34">
	                <el-col :span="14">
	                  <el-input @keyup.native.enter="submit()" size="small"  v-model="captcha" auto-complete="off" placeholder="请输入验证码">
	                    <i slot="prefix" class="el-icon-mobile"/>
	                  </el-input>
	                </el-col>
	                <el-col :span="10">
	                  <div class="login-code">
	                    <img :src="img" class="login-code-img" style="cursor: pointer;" @click="refresCaptcha" alt=""/>
	                  </div>
	                </el-col>
	              </el-row>
	            </el-form-item>
	            <!-- <el-checkbox v-model="checked">保持登录</el-checkbox> -->
	            <el-form-item>
	              <el-button
	                type="primary"
	                size="small"
	                @click.native.prevent="submit()"
	                class="login-submit">登 录
	              </el-button>
	            </el-form-item>
	          </el-form>
	      </div>
	    </div>
	  </div>
</template>

<script>
	export default {
		name: 'Login',
		data(){
				return{
					username:"",
					password:"",
					checked: false,
					img:'',
					captcha:'',
					token:'',
				}
			},
		methods: {
			submit(){
				this.httpPost({
				  url:"/admin/login/login",
				  data:{
					  username:this.username,
					  password:this.password,
					  captcha:this.captcha,
					  token:this.token,
				  }
				}).then((res)=>{
							
				  // console.log(res);
				  if(res.code ==1){
					  // console.log(res);
						// window.location.href="http://www.baidu.com" 
						// this.localSet('token', res.data);
						 this.alertSuccess('登录成功')
						this.$router.push({name: 'Home'});
				  }
				}).catch((err)=>{
					// this.alertError('登录失败')
					this.getCaptcha();
					// this.$message.error(err.data.msg);
					  // this.$message.error(err.data.msg);
				})
			},
			getCaptcha(){
			
			        this.httpPost({
			          url:"/admin/captcha/getCaptcha"
			        }).then((re)=>{
			
			          // console.log(re);
			
			          this.img=re.data.image;
			          this.token=re.data.token;
			
			
			        })
			
			
			      },
			refresCaptcha(){
			        this.getCaptcha()
			      },	  
		},
		// beforeCreate(){
		// 	if(this.localGet('token')) return this.$router.push('/main/home')
		// },
		created(){
			this.getCaptcha();
		}
		
	};
</script>
<style lang="scss">
	body #app, html #app {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
html, body, #app {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}
  .login-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
	height: 100%;
    background-image: url('../../../public/login-bg.jpg');
    background-size: cover;
  }

  .login-info {
    padding-left: 60px;
  }

  .login-info-title {
    line-height: 90px;
  }

  .login-info-item {
    font-size: 14px;
  }

  .login-border {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 30px 55px 25px 55px;
    background-color: rgba(255, 255, 255, 0.12);
    border-radius: 6px;
  }

  .login-main {
    border-radius: 3px;
    box-sizing: border-box;
  }

  .login-main > h3 {
    margin-bottom: 20px;
  }

  .login-main > p {
    color: #76838F;
  }

  .login-logo {
    margin: 0 0 20px;
    text-align: center;
  }

  .login-submit {
    margin-top: 20px;
    width: 100%;
  }

  .login-form {
    margin: 10px 0;

    .el-form-item__content {
      width: 270px;
    }

    .el-form-item {
      margin-bottom: 15px;
    }

    .el-input {
      input {
        text-indent: 5px;
        border-color: #DCDCDC;
        border-radius: 3px;
      }

      .el-input__prefix {
        i {
          padding: 0 5px;
          font-size: 16px !important;
        }
      }
    }
  }

  .login-code {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-left: 10px;
  }

  .login-code-img {
    margin-top: 5px;
    width: 100px;
    height: 31px;
  }
</style>
